import React, { useState } from "react";
import { Card, Row, Col, Badge, Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import EditarRegistroCalendario from "./EditarRegistroCalendario";
import { cancelarRegistro } from "../../api/common";
import { Alertassw } from "../Alertas/Alertassw";

const TIPO_LABEL = {
  permiso: 'Permiso',
  vacaciones: 'Vacaciones',
  incapacidad: 'Incapacidad',
  capacitacion: 'Capacitación',
  teletrabajo: 'Teletrabajo',
  compensatorio: 'Compensatorio',
};

const DetalleRegistro = ({ evento, setDetalleRegistro,  isOpen, setIsOpen, setRefresh }) => {

    const [viewRepogramar, setViewRepogramar]=useState(false)
  if (!evento) {
    return (
      <Card className="shadow-sm text-center p-4">
        <p className="text-muted">Selecciona un evento para ver su detalle</p>
      </Card>
    );
  }

  const formatDate = (date) => {
    if (!date) return "Sin fecha";
    return new Date(date).toLocaleString("es-CO", {
      weekday: "short",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleCancelar = async () => {
    try {
        const result = await Swal.fire({
          title: "¿Cancelar este registro?",
          text: "Esta acción no se puede deshacer",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Sí, cancelar",
          cancelButtonText: "Volver",
        });

        if (result.isConfirmed) {
          await cancelarRegistro(evento.id, {});
          Alertassw('success', 'Registro cancelado correctamente');
          setRefresh(prev => !prev);
          setIsOpen(false);
        }
    } catch (error) {
      Alertassw('error', 'No se pudo cancelar el registro');
      setIsOpen(false);
    }
  };

  const handleReprogramarExito = () => {
    setRefresh(prev => !prev);
    setViewRepogramar(false);
    setIsOpen(false);
  };

  const solicitanteNombre = evento.solicitante
    ? `${evento.solicitante.nombre || ''} ${evento.solicitante.apellido || ''}`.trim()
    : '—';

  return (
    <>
        <Modal show={isOpen} onHide={() => setIsOpen(false)} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Detalle del evento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {viewRepogramar
              ? <EditarRegistroCalendario
                  evento={evento}
                  onExito={handleReprogramarExito}
                  onCancelar={() => setViewRepogramar(false)}
                />
              :
            <Card className="shadow-sm p-4 mx-auto" style={{ maxWidth: '700px', width: '100%' }}>
                <div className="d-flex justify-content-between align-items-center mb-3 w-100">
                    <h5 className="fw-bold mb-0 text-primary">{evento?.title}</h5>
                    <Badge bg={evento.estado === "aprobado" ? "success" : "secondary"}>
                    {evento.estado || "Pendiente"}
                    </Badge>
                </div>

                <Row className="mb-2">
                    <Col md={6}>
                    <small className="text-muted fw-bold">Inicio</small>
                    <p className="mb-1">{formatDate(evento.start)}</p>
                    </Col>
                    <Col md={6}>
                    <small className="text-muted fw-bold">Fin</small>
                    <p className="mb-1">{formatDate(evento.end)}</p>
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col md={6}>
                    <small className="text-muted fw-bold">Tipo</small>
                    <p className="mb-1">{TIPO_LABEL[evento.tipo] || evento.tipo || '—'}</p>
                    </Col>
                    <Col md={6}>
                    <small className="text-muted fw-bold">Causa inactividad</small>
                    <p className="mb-1">{evento.causaInactividad ? 'Sí' : 'No'}</p>
                    </Col>
                </Row>

                {evento.asistentes?.length > 0 && (
                <div className="mb-2 w-100">
                  <small className="text-muted fw-bold">Asistentes</small>
                  <ul className="mb-1 ps-3">
                    {evento.asistentes.map((a, i) => (
                      <li key={a._id || i}>
                        {a.nombre ? `${a.nombre} ${a.apellido || ''}` : String(a)}
                      </li>
                    ))}
                  </ul>
                </div>
                )}

                <div className="mb-2 w-100">
                    <small className="text-muted fw-bold">Descripción</small>
                    <p className="mb-1">{evento.descripcion || "Sin descripción"}</p>
                </div>

                <Row className="mb-2 w-100">
                    <Col md={6}>
                    <small className="text-muted fw-bold">Solicitante</small>
                    <p className="mb-1">{solicitanteNombre}</p>
                    </Col>
                </Row>

                <div className="text-end mt-3">
                    <small className="text-muted fw-bold">
                    Creado el {formatDate(evento.createdAt)}
                    </small>
                </div>

                {evento.puedeEditar && (
                  <>
                    <hr/>
                    <div className='button-controller d-flex gap-2'>
                      <Button variant='warning' size='sm' onClick={() => setViewRepogramar(true)}>Reprogramar</Button>
                      <Button variant='danger' size='sm' onClick={handleCancelar}>Cancelar</Button>
                    </div>
                  </>
                )}
                </Card>
                }
            </Modal.Body>
        </Modal>
    </>
  );
};

export default DetalleRegistro;
